import { Form } from "react-bootstrap";

import { FormControlWrapper } from "./formControlWrapper";
import { getDropdownValue } from "..";

export const FieldDropdown = ({
	isDisabled,
	// TODO: understand how to make this better
	isForced = false,
	error,
	fieldData,
	isMandatory,
	dropdownData = [],
	placeholder = "",
	title = "",
	autoFocus,
	tooltip,
	setValue = (_value) => {},
}) => {
	const defVal = getDropdownValue({
		isMandatory,
		dropdownData,
		valueToFind: fieldData,
	});

	return (
		<FormControlWrapper
			title={title}
			tooltip={tooltip}
			data-testid="test-fieldDropdown"
			error={error}
		>
			<Form.Select
				data-testid="test-fieldDropdownControl"
				onChange={(e) => setValue(e.target.value)}
				isInvalid={!!error}
				disabled={isDisabled}
				// TODO: move to utils
				// A <select> must be either controlled (value) or
				// uncontrolled (defaultValue), never both. When forced we
				// control it; otherwise it stays uncontrolled with a default.
				value={isForced ? defVal : undefined}
				defaultValue={isForced ? undefined : defVal}
				autoFocus={autoFocus}
			>
				{!isMandatory ? (
					<option value={-1}>{placeholder}</option>
				) : null}
				{dropdownData?.map(({ id, label }, index) => (
					<option key={index} value={id}>
						{label}
					</option>
				))}
			</Form.Select>
		</FormControlWrapper>
	);
};
